(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["snl-quick-view"] && !Shopify.designMode) return;
  try {
    (function () {
    var modal = document.getElementById('SnlQuickView');
    if (!modal) return;
    var dialog = modal.querySelector('.snl-qv-modal__dialog');
    var body = modal.querySelector('[data-snl-qv-body]');
    var loadingHTML = '<div class="snl-qv-modal__loading">Loading…</div>';
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      dialog.focus();
      document.addEventListener('keydown', onKey);
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('keydown', onKey);
      var done = function () { modal.hidden = true; body.innerHTML = loadingHTML; modal.removeEventListener('transitionend', done); };
      modal.addEventListener('transitionend', done);
      setTimeout(done, 300);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    function load(handle) {
      body.innerHTML = loadingHTML;
      open();
      fetch('/products/' + encodeURIComponent(handle) + '?section_id=snl-quick-view-content')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('.snl-qv');
          if (content) { body.innerHTML = ''; body.appendChild(content); dialog.focus(); }
          else { window.location = '/products/' + handle; }
        })
        .catch(function () { window.location = '/products/' + handle; });
    }

    // Open triggers (product cards)
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-snl-quick-view]');
      if (trigger) { e.preventDefault(); load(trigger.getAttribute('data-snl-quick-view')); return; }
      if (e.target.closest('[data-snl-qv-close]')) { close(); return; }
      if (e.target === modal || e.target.hasAttribute('data-snl-qv-backdrop')) { close(); return; }

      // in-modal: qty stepper
      var stepBtn = e.target.closest('.snl-qv-stepper__btn');
      if (stepBtn && modal.contains(stepBtn)) {
        var input = stepBtn.parentNode.querySelector('.snl-qv-stepper__input');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(stepBtn.dataset.step, 10));
        // Setting .value doesn't fire anything on its own — announce it so the
        // multi-unit note and pop-up react here the same way they do on the PDP.
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      // in-modal: quote button
      var quote = e.target.closest('[data-snl-qv-quote]');
      if (quote && modal.contains(quote)) { window.location = quote.getAttribute('data-href') || '#'; return; }
    });

    // When product-form.js adds the item and opens the cart drawer, close the
    // quick view (no timer race with the async add).
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(function () {
        if (drawer.classList.contains('active') && !modal.hidden) close();
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
